import { Title, Group, Divider } from '@mantine/core';
import { ActionButton } from './ActionButton';

interface SectionHeaderProps {
  title: string;
  action?: {
    label: string;
    onClick: () => void;
    ariaLabel?: string;
  };
}

export function SectionHeader({ title, action }: Readonly<SectionHeaderProps>) {
  return (
    <>
      <Group position="apart" mb="lg">
        <Title order={3} weight={500}>{title}</Title>
        {action && (
          <ActionButton
            onClick={action.onClick}
            label={action.label}
            ariaLabel={action.ariaLabel || action.label}
            actionType="secondary"
          />
        )}
      </Group>
      <Divider mb="xl" />
    </>
  );
} 